import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Description, Title } from './elements'

export const Cobee = () => {
  return (
    <>
      <Title>{i18n.t('app_store_v2.integrations.cobee.description_view.title_1')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.cobee.description_view.description_1')}
      </Description>
      <Title>{i18n.t('app_store_v2.integrations.google_calendar.description_view.title_2')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.cobee.description_view.description_2_1')}
        <a href="https://cobee.io/factorial/">
          <Text.Normal dotted color="grey800">
            {i18n.t('app_store_v2.integrations.cobee.description_view.form')}
          </Text.Normal>
        </a>
        {i18n.t('app_store_v2.integrations.cobee.description_view.description_2_2')}
      </Description>
    </>
  )
}
